import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ChatResolveButtonComponent } from './chat-resolve-button.component';

@NgModule({
  declarations: [ChatResolveButtonComponent],
  imports: [CommonModule, MatButtonModule, MatTooltipModule, FontAwesomeModule],
  exports: [ChatResolveButtonComponent],
})
export class ChatResolveButtonModule {}
